
import React from 'react';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

interface TenureFieldProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
}

const TenureField = ({ id, label, value, onChange }: TenureFieldProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor={id}>{label}</Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger 
          id={id}
          className="w-full transition-all duration-200 focus-visible:ring-redflags-red/30"
        >
          <SelectValue placeholder="Select your tenure" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="0-6 Months">0-6 Months</SelectItem>
          <SelectItem value="6-12 Months">6-12 Months</SelectItem>
          <SelectItem value="1-3 Years">1-3 Years</SelectItem>
          <SelectItem value="3-5 Years">3-5 Years</SelectItem>
          <SelectItem value="5+ Years">5+ Years</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default TenureField;
